module.exports = __webpack_public_path__ + "img/29.ce636717.png";